import { render, staticRenderFns } from "./72shadowAnalyse.vue?vue&type=template&id=13ca65a6&scoped=true&"
import script from "./72shadowAnalyse.vue?vue&type=script&lang=js&"
export * from "./72shadowAnalyse.vue?vue&type=script&lang=js&"
import style0 from "./72shadowAnalyse.vue?vue&type=style&index=0&id=13ca65a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca65a6",
  null
  
)

export default component.exports